<template>
  <div v-if="reviewTags.length" class="tags-selection flex flex-row flex-wrap p-5 -mx-5">
    <template v-for="tag in reviewTags" :key="tag.id">
      <etg-button
        v-if="typeof tag.id === 'number'"
        :size="props.tagSize"
        type="secondary"
        :class="{ active: selectedReviewTagId === tag.id }"
        @click="$emit('tag-click', tag.id)"
      >
        {{ tag.name }}({{ tag.count }})
      </etg-button>
    </template>
  </div>
</template>

<script lang="ts" setup>
import { DEFAULT_REVIEW_TAG_ID } from '@/constants/commons'
import type { EtgButtonProps } from '@/types/component'

interface Props {
  pid: string | number
  selectedReviewTagId?: number
  tagSize?: EtgButtonProps['size']
}

interface Emits {
  (event: 'tag-click', tagId: number): void
}

const props = withDefaults(defineProps<Props>(), { tagSize: 'mini' })
const { pid, selectedReviewTagId } = toRefs(props)

defineEmits<Emits>()

const { data: reviewTagsCountData } = useGetProductReviewTagsCount(pid)

const { t } = useI18n()

const reviewTags = computed(() => {
  if (!reviewTagsCountData.value?.tags || reviewTagsCountData.value.tags.length === 0) {
    return []
  }

  const allTag = { id: DEFAULT_REVIEW_TAG_ID, name: t('comment.filter.all'), count: reviewTagsCountData.value.total_reviews_count || 0 }

  return [allTag, ...reviewTagsCountData.value.tags]
})
</script>
